import { CategoryFilterValues, CategoryGetResponse, CategoryParams, CategoryValues } from '../model/categoryModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export enum CATEGORY_TYPES {
  SET_API_CATEGORY_REQUEST_STATE = 'SET_API_CATEGORY_REQUEST_STATE',
  SET_API_CATEGORY_REQUEST_ERROR = 'SET_API_CATEGORY_REQUEST_ERROR',
  SET_API_CATEGORIES_REQUEST_STATE = 'SET_API_CATEGORIES_REQUEST_STATE',
  SET_API_CATEGORIES_REQUEST_ERROR = 'SET_API_CATEGORIES_REQUEST_ERROR',
  ADD = 'CATEGORY_ADD',
  EDIT = 'CATEGORY_EDIT',
  DELETE = 'CATEGORY_DELETE',
  GET_ALL = 'CATEGORY_GET_ALL',
  GET_ALL_SUCCESS = 'CATEGORY_GET_ALL_SUCCESS',
  GET_ONE = 'CATEGORY_GET_ONE',
  GET_ONE_SUCCESS = 'CATEGORY_GET_ONE_SUCCESS',
  RESET = 'CATEGORY_RESET',
  GET_TREE = 'GET_TREE',
  GET_TREE_SUCCESS = 'GET_TREE_SUCCESS',
}

export interface SetApiCategoryRequestStateAction {
  type: CATEGORY_TYPES.SET_API_CATEGORY_REQUEST_STATE;
  payload: {
    apiCategoryRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiCategoryRequestErrorAction {
  type: CATEGORY_TYPES.SET_API_CATEGORY_REQUEST_ERROR;
  payload: {
    apiCategoryRequestError: string;
  };
}

export interface SetApiCategoriesRequestStateAction {
  type: CATEGORY_TYPES.SET_API_CATEGORIES_REQUEST_STATE;
  payload: {
    apiCategoriesRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiCategoriesRequestErrorAction {
  type: CATEGORY_TYPES.SET_API_CATEGORIES_REQUEST_ERROR;
  payload: {
    apiCategoriesRequestError: string;
  };
}

export interface AddCategoryAction {
  type: CATEGORY_TYPES.ADD;
  payload: {
    category: CategoryValues;
  };
}

export interface EditCategoryAction {
  type: CATEGORY_TYPES.EDIT;
  payload: {
    category: CategoryValues;
    params: CategoryParams;
  };
}

export interface DeleteCategoryAction {
  type: CATEGORY_TYPES.DELETE;
  payload: {
    params: CategoryParams;
  };
}

export interface GetOneCategoryAction {
  type: CATEGORY_TYPES.GET_ONE;
  payload: {
    params: CategoryParams;
  };
}

export interface ResetCategoryAction {
  type: CATEGORY_TYPES.RESET;
  payload: null;
}

export interface GetOneCategorySuccessAction {
  type: CATEGORY_TYPES.GET_ONE_SUCCESS;
  payload: {
    category: CategoryGetResponse;
  };
}

export interface GetAllCategoriesAction {
  type: CATEGORY_TYPES.GET_ALL;
  payload: {
    categoryFilter: CategoryFilterValues;
  };
}

export interface GetAllCategoriesSuccessAction {
  type: CATEGORY_TYPES.GET_ALL_SUCCESS;
  payload: {
    categories: CategoryGetResponse[];
  };
}

export interface GetCategoriesTreeAction {
  type: CATEGORY_TYPES.GET_TREE;
  payload: {
    params: CategoryParams;
  };
}

export interface GetCategoriesTreeSuccessAction {
  type: CATEGORY_TYPES.GET_TREE_SUCCESS;
  payload: {
    categories: CategoryGetResponse[];
  };
}

export type CategoryActions =
  | SetApiCategoryRequestStateAction
  | SetApiCategoryRequestErrorAction
  | SetApiCategoriesRequestStateAction
  | SetApiCategoriesRequestErrorAction
  | ResetCategoryAction
  | AddCategoryAction
  | EditCategoryAction
  | GetOneCategoryAction
  | GetOneCategorySuccessAction
  | GetAllCategoriesAction
  | GetCategoriesTreeAction
  | GetCategoriesTreeSuccessAction
  | GetAllCategoriesSuccessAction;

export interface CategoryState {
  apiCategoryRequestState: API_REQUEST_STATE;
  apiCategoryRequestError: string | null;
  apiCategoriesRequestState: API_REQUEST_STATE;
  apiCategoriesRequestError: string | null;
  category: CategoryGetResponse;
  categories: CategoryGetResponse[];
  categoriesTree: CategoryGetResponse[];
}
